import { COLORS } from "../../utils/js/constants";

export default function inputSearchStyle(theme) {
    return {
        inputSell: {
            color: COLORS.white,
            opacity: 0.5
        }
    }
}
